function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "suggest-candidate",
  transform: "translate(-1018.000000, -1002.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "item-candidate",
  transform: "translate(959.000000, 952.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-linkedin",
  transform: "translate(59.000000, 50.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#0E5883",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.000000, 4.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.55964379,3.3 L0.190356208,3.3 C0.0852034389,3.3 0,3.38212482 0,3.48339621 L0,10.8166038 C0,10.9179119 0.0852034389,11 0.190356208,11 L2.55964379,11 C2.66479656,11 2.75,10.9179119 2.75,10.8166038 L2.75,3.48339621 C2.75,3.38212482 2.66479656,3.3 2.55964379,3.3 Z",
  id: "XMLID_802_"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.37555269,0 C0.617065981,0 0,0.616696523 0,1.37471514 C0,2.13306889 0.617065981,2.75 1.37555269,2.75 C2.13343646,2.75 2.75,2.13303538 2.75,1.37471514 C2.7500335,0.616696523 2.13343646,0 1.37555269,0 Z",
  id: "XMLID_803_"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.20958327,3.3 C7.33277656,3.3 6.68461663,3.68500358 6.29148309,4.12246368 L6.29148309,3.65719876 C6.29148309,3.5582695 6.21297566,3.478044 6.11608667,3.478044 L4.02539642,3.478044 C3.92850744,3.478044 3.85,3.5582695 3.85,3.65719876 L3.85,10.8208094 C3.85,10.9197745 3.92850744,11 4.02539642,11 L6.20371472,11 C6.30060371,11 6.37911114,10.9197745 6.37911114,10.8208094 L6.37911114,7.27648326 C6.37911114,6.08213013 6.69671898,5.61682938 7.51182123,5.61682938 C8.39953759,5.61682938 8.47008203,6.36275815 8.47008203,7.33793335 L8.47008203,10.8208452 C8.47008203,10.9198103 8.54858947,11 8.64547845,11 L10.8246036,11 C10.9214926,11 11,10.9198103 11,10.8208452 L11,6.89147968 C11,5.11551853 10.6684657,3.3 8.20958327,3.3 Z",
  id: "XMLID_804_"
}))))));

function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.10f924e6.svg";
export { ForwardRef as ReactComponent };